import EntityPage from '../EntityPage/EntityPage';

const Asset = () => {
    return <EntityPage entityType="Asset" />;
};

export default Asset;
